import Styleguide, { Colors, theme } from "src/theme";
import styled from "styled-components";

const Label = styled.label`
  color: ${theme(Colors.gray[300], Colors.gray[200])};

  > p {
    margin: 0;
  }
`;

const Span = styled.span`
  color: ${theme(Colors.gray[300], Colors.gray[200])};
  font-style: italic;
`;

const InputContainer = styled.div<{
  invalid: boolean;
  typeFieldMessage: string;
}>`
  display: flex;
  align-items: center;
  height: 40px;
  border: 1px solid;
  border-radius: 8px;
  overflow: hidden;

  background: ${theme(Colors.white, Colors.gray[500])};
  border-color: ${props => {
    if (props.invalid && props.typeFieldMessage !== "info") {
      if (props.typeFieldMessage === "error") {
        return theme(Colors.red[100], Colors.lightRed[100]);
      }
      return theme(Colors.orange[100], Colors.lightOrange[100]);
    }
    return theme(Colors.gray[300], Colors.gray[200]);
  }};

  :focus-within {
    border-color: ${theme(Colors.blue[100], Colors.lightBlue[100])};
  }

  @media (min-width: ${Styleguide.breakpoints.desktop}) {
    height: 48px;
  }
`;

const StyledInput = styled.input`
  height: 100%;
  padding: 0 12px;
  border: none;
  flex: 1;
  font-size: ${Styleguide.fontSizes[16]};
  line-height: 18px;
  letter-spacing: 0em;
  text-align: left;
  color: ${theme(Colors.black, Colors.white)};
  background: inherit;

  :focus {
    outline: none;
  }

  ::placeholder {
    font-style: italic;
    color: ${theme(Colors.gray[300], Colors.gray[200])};
  }

  @media screen and (min-width: ${Styleguide.breakpoints.tablet}) {
    font-size: ${Styleguide.fontSizes[18]};
  }
`;

const Prefix = styled.div`
  margin-left: 8px;
  display: flex;
`;

const Suffix = styled.span`
  display: flex;
  margin-left: 8px;
  margin-right: 12px;
`;

export { Label, Span, InputContainer, StyledInput, Prefix, Suffix };
